export default __webpack_public_path__ + "static/media/GolosMedium.eb23274f.woff2";